import React, { Fragment, useEffect, useState } from 'react'; 
import HeroSection from '../../Components/Main/Common/HeroSection';
import '../../CSS/Main/portfolio.scss';
import PortfolioContent from '../../Components/Main/Portfolio/PortfolioContent';
import ContentHeader from '../../Components/Main/Portfolio/ContentHeader';
import PortfolioImage from '../../Images/portfolio.jpg';
import {RefreshCw} from 'react-feather';
import { fetchData } from '../../Utility/GlobalService';
import getUrl from '../../Utility/GetUrl';
import {Dots} from 'react-preloaders2';


const Portfolio = ()=> { 
  useEffect(()=>{
    getPortfolioDataList();
    getPortfolioSubDataList();
    getPortfolioWork();
    setLoading(false);
  },[]);
  
  const [loading,setLoading] = useState(true);
  const [portfolioPageContent,setPortfolioPageContent] = useState();
  const [portfolioPageSubContent,setPortfolioPageSubContent] = useState();
  const [portfolioWorkList,setPortfolioWorkList] = useState();
  
  const getPortfolioDataList = async()=>{
    const response = await fetchData(`${getUrl()}/portfoliopage`);
    setPortfolioPageContent(response);
  }
  const getPortfolioSubDataList = async()=>{
    const response = await fetchData(`${getUrl()}/portfoliopage/subcontent`);
    setPortfolioPageSubContent(response);
  }
  const getPortfolioWork = async()=>{
    const response = await fetchData(`${getUrl()}/work/list`);
    setPortfolioWorkList(response);
    // console.log(response);
  }
  const portfolioSectionContent = {
    title: "SILENT PEOPLE HAVE THE LOUDEST MIND",
    content: `WORK DEFINES A PERSON, BUT CODING STRUCTURE AND MAINTAINING BETTER  CODING PRINCIPLE DEFINES A BETTER  SOFTWARE ENGINEER!`  
  }
  const portfolioHeaderContent = {
    title: "HAVE SOME FUN WITH MY WORKS",
    content: `HOPE YOU WILL ENJOY`  
  }
  // console.log(PortfolioImage);
  const portfolios = [
    {
      image: `${PortfolioImage}`,
      stack: "MERN",
      liveLink: "https://www.google.com",
      technologies: [
        "MONGODB","EXPRESS JS","REACT JS","NODEJS",
      ]
    },
    {
      image: `${PortfolioImage}`,
      stack: "MNRN",
      liveLink: "https://www.google.com",
      technologies: [
        "MONGODB","NEST JS","REACT JS","NODEJS",
      ]
    }
  ]

  const loadMoreData = ()=>{
    // console.log('more data on the way!');
  }
  return (
    <Fragment>
      <Dots background="#000" color="#00FFA5" customLoading={loading}/>
      <div className="portfolio-page">
          <div className="portfolio-hero-section">
            {portfolioPageContent && <HeroSection data={portfolioPageContent}/>}
          </div>
          <div className="portfolio-content-section">
            {portfolioPageSubContent && <ContentHeader data={portfolioPageSubContent}
            className="portfolio-header-content"/>}
            {portfolioWorkList && <PortfolioContent data={portfolioWorkList}/>}
          <div className="portfolio-load-more">
            <div className="container">
              <div className="row mt-5 pb-5">
                <div className="col-md-4 col-lg-4"></div>
                <div className="col-md-4 col-lg-4">
                <button onClick={loadMoreData}
                className="load-more-btn">LOAD MORE 
                  <span className="refresh-icon"><RefreshCw/></span></button>
                </div>
                <div className="col-md-4 col-lg-4"></div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </Fragment>
  );
}

export default Portfolio; 